export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
}

export function setCookie(
  name: string,
  value: string | object,
  options?: {
    req?: unknown;
    res?: unknown;
    path?: string;
    domain?: string;
    expires?: Date | string;
    maxAge?: number;
    secure?: boolean;
    httpOnly?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
  }
): void {
  if (typeof document === 'undefined') return;

  const cookieValue = typeof value === 'string' ? value : JSON.stringify(value);
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(cookieValue)}`;

  if (options) {
    if (options.path) cookie += `; path=${options.path}`;
    if (options.domain) cookie += `; domain=${options.domain}`;
    if (options.expires) {
      const expires = options.expires instanceof Date ? options.expires : new Date(options.expires);
      cookie += `; expires=${expires.toUTCString()}`;
    }
    if (options.maxAge) cookie += `; max-age=${options.maxAge}`;
    if (options.secure) cookie += '; secure';
    if (options.sameSite) cookie += `; samesite=${options.sameSite}`;
  } else {
    // Default: 1 year expiry
    const expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
    cookie += `; expires=${expires.toUTCString()}; path=/`;
  }

  document.cookie = cookie;
}
